<div class="flex flex-row justify-center items-center">
  <div class="main-verification-container flex flex-col gap-6">
    @if (notificationType) {
      @if (notificationType === passwordCodeNotificationValues.code_resent) {
        <pin-notification id="success-notification" class="w-full" type="success">
          We have sent you a new verification code.
        </pin-notification>
      } @else {
        <pin-notification id="alert-notification" class="w-full" type="alert">
          @switch (notificationType) {
            @case (passwordCodeNotificationValues.code_expired) {
              The code you entered has expired. Try requesting a new code.
            }
            @case (passwordCodeNotificationValues.code_incorrect) {
              @if (mfaOption !== 'SOFTWARE_TOKEN_MFA' && setupPhase) {
                The code you entered was incorrect. Try re-entering your code or request a new code.
              } @else {
                The code you entered was incorrect. Try re-entering your code.
              }
            }
            @case (passwordCodeNotificationValues.too_many_tries) {
              Too many attempts. Please try again later or choose the
                @if (mfaOption !== 'SOFTWARE_TOKEN_MFA') {
                  <pin-button buttonStyle="link" customClass="pb-1!" [redirectUrl]="authenticatorAppUrl" [skipLocationChange]="true">
                      Authenticator App method
                  </pin-button>
                } @else {
                  <pin-button buttonStyle="link" customClass="pb-1!" [redirectUrl]="emailUrl" [queryParams]="{setupEmail: true}" [skipLocationChange]="true">
                      Email method
                  </pin-button>
                }.
            }
          }
        </pin-notification>
      }
    }

    <form id="verification-code-form" [formGroup]="verifyCodeForm" (ngSubmit)="confirmVerificationCode()">
      <div class="flex flex-col confirmation-code-main-container gap-3">
        <div class="flex flex-col gap-6 lt-md:gap-4">
          <div class="flex flex-col gap-4">
            <div id="verification-code-title" class="dcp-h2 flex justify-start items-center">
              @if (!setupPhase && mfaOption !== 'SOFTWARE_TOKEN_MFA') {
                We Sent You An Authentication Code
              }
              @if (mfaOption === 'SOFTWARE_TOKEN_MFA') {
                Enter the code you have received in the Authenticator App
              }
              @if (setupPhase) {
                <span>
                    @switch (mfaOption) {
                      @case ('EMAIL_MFA') {
                        Verify Email Code
                      }
                      @case ('SMS_MFA') {
                        We Sent You A Text Message
                      }
                    }
                  </span>
              }
            </div>
            @switch (mfaOption) {
              @case ('EMAIL_MFA') {
                <div id="email-mfa-text">
                  <p class="dcp-body">
                    A verification code has been sent to the email address used at registration. Enter the code to
                    continue.
                  </p>
                </div>
              }
              @case ('SMS_MFA') {
                <div id="sms-mfa-text">
                  <p class="dcp-body">
                    A verification code has been sent to your device.<br>Enter the code to continue.
                  </p>
                </div>
              }
            }
          </div>
          <div id="enter-code-input" class="flex flex-row justify-center items-center code-input-width">
            <mat-form-field class="code-input-width" appearance="outline" id="verification.code">
              <mat-label>Enter your code</mat-label>
              <input matInput
                     placeholder="Enter your code"
                     formControlName="code"
                     (keyup)="verifyCodeForm.controls['code'].markAsTouched()" pinDigitsOnly pinAutoFocus>
                <mat-error id="code.required">
                  This field is <strong>required</strong>
                </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-col gap-4">
          <div class="flex flex-row justify-center items-center">
            <div id="confirm-code-button" class="button-wide">
               <pin-button buttonStyle="filled" buttonId="mfa-confirm-code-button" [isDisabled]="processingRequest">CONFIRM VERIFICATION CODE</pin-button>
            </div>
          </div>
          @if (mfaOption === 'EMAIL_MFA') {
             <div class="flex flex-col md:flex-row gap-2 justify-center items-center">
               <p id="request-code-email-mfa-text" class="dcp-body">
                 Having trouble receiving your code?
               </p>
                <pin-button id="mfa-try-again-button" buttonStyle="link" buttonType="button"
                           (buttonClick)="requestNewCode()" [isDisabled]="requestingNewCode">Try again.
               </pin-button>
             </div>
          }
          @if (setupPhase) {
            <div class="flex flex-col gap-4 justify-center items-center" id="footer">
              @if (mfaOption === 'SOFTWARE_TOKEN_MFA') {
                <p class="dcp-body">Having trouble?</p>
              }
              <pin-button id="back-to-setup-button" buttonStyle="link" customClass="pb-1!" buttonType="button"
                          (buttonClick)="backToSetup()" [isDisabled]="navigatingBack">
                Try a different verification method.
              </pin-button>
            </div>
          }
        </div>
      </div>
    </form>
  </div>
</div>

@if (processingRequest) {
  <div class="pin-spinner fullscreen">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}
